// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uuF7njLXKsFouj__ws9_{flex-direction:column;height:100%;display:flex;overflow:auto}.SqzrbKQn08wEBvtydqwF{background:var(--background-brand-subtle-primary);border-radius:6px;flex-direction:column;gap:8px;padding:8px 12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exampleModal": `uuF7njLXKsFouj__ws9_`,
	"exampleModalText": `SqzrbKQn08wEBvtydqwF`
};
export default ___CSS_LOADER_EXPORT___;
